import React from 'react'

import { getAbsenteeismSummaryText, toPercent } from './constants'

import s from './styles.module.scss'

function AbsenteeismSummary({ absentPercentage }) {
  const { absentism = 0, absentTurns = 0, totalTurns = 0 } = absentPercentage || {}

  const percent = toPercent(absentism)
  const summaryText = getAbsenteeismSummaryText(absentTurns, totalTurns)

  return <div className={s.absentTurns}>{`Ausentismo: ${percent}% (${summaryText})`}</div>
}

export default AbsenteeismSummary
